import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import {
    stripData,
    multStripData
} from './feedbackconfig';
import { submitFeed } from '../api/feedback';
var Feedback = function () {
    function Feedback(player) {
        var _this = this;
        _classCallCheck(this, Feedback);
        this.player = player;
        this.isVideoPaused = false;
        this.player.template.feedbackButton.addEventListener('click', function () {
            _this.show();
        });
        this.player.template.feedbackPanelClose.addEventListener('click', function () {
            _this.hide();
        });
        this.container = this.player.template.feedbackPanelContainer;
    }
    _createClass(Feedback, [
        {
            key: 'init',
            value: function init() {
                var feedCode = 0;
                var stripHtml = stripData.map(function (item) {
                    feedCode++;
                    var feedTitle = '<p class="dplayer-feedtitle">'.concat(item.title, '</p>');
                    var feedList = item.likeChoose.map(function (likeItem) {
                        return '<li class="dplayer-feed-content" data-title="'.concat(item.title, '" data-feed="Question_').concat(feedCode, '" data-code="').concat(likeItem.id, '" data-text="').concat(likeItem.text, '" data-curStatus="').concat(likeItem.curStatus, '" data-text_id="').concat(likeItem.text_id, '">').concat(likeItem.text, '</li>');
                    }).join('');
                    return ''.concat(feedTitle, '<ul class="dplayer-feed-list">').concat(feedList, '</ul>');
                }).join('');
                var multStripHtml = multStripData.map(function (item) {
                    feedCode++;
                    var feedTitle = '<p class="dplayer-feedtitle">'.concat(item.title, '</p>');
                    var feedList = item.likeChoose.map(function (likeItem) {
                        return '<li class="dplayer-feed-content" data-feed="Question_'.concat(feedCode, '" data-code="').concat(likeItem.id, '" data-text="').concat(likeItem.text, '" data-curStatus="').concat(likeItem.curStatus, '" data-text_id="').concat(likeItem.text_id, '">').concat(likeItem.text, '</li>');
                    }).join('');
                    return ''.concat(feedTitle, '<ul class="dplayer-feed-list">').concat(feedList, '</ul>');
                }).join('');
                this.container.innerHTML = '<div class="dplayer-feedback-strip">'.concat(stripHtml, '</div><div class="dplayer-feedback-mult">').concat(multStripHtml, '<div class="textarea"><textarea class="zd_textarea" ref="textarea" maxlength="50" placeholder="输入其他原因"></textarea></div></div><div class="dplayer-feedback-btn unable">确定</div>');
                this.initClickEvents();
                this.submitButton = this.container.querySelector('.dplayer-feedback-btn');
            }
        },
        {
            key: 'submitFeedInfo',
            value: function () {
                var _submitFeedInfo = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
                    var _player, feedData, feedLi, i, multchecked, feedMultLi, _i, submitUrl, submitParams, submitInfo;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                _player = this;
                                feedData = [];
                                feedLi = this.player.template.feedbackStripList.querySelectorAll('li.dplayer-feed-content');
                                for (i = 0; i < feedLi.length; i++) {
                                    if (feedLi[i].classList.contains('active')) {
                                        feedData.push({
                                            question_title: feedLi[i].dataset.title,
                                            question_id: feedLi[i].dataset.feed,
                                            content_checked: {
                                                checked: {
                                                    'id': feedLi[i].dataset.code,
                                                    'text': feedLi[i].dataset.text,
                                                    'code': feedLi[i].dataset.code,
                                                    'curStatus': true,
                                                    'text_id': feedLi[i].dataset.text_id,
                                                    'active': true
                                                }
                                            }
                                        });
                                    }
                                }
                                if (!this.container.classList.contains('dplayer-feedback-wrap-mult-hide')) {
                                    multchecked = [];
                                    feedMultLi = this.player.template.feedbackMultList.querySelectorAll('li.dplayer-feed-content');
                                    for (_i = 0; _i < feedMultLi.length; _i++) {
                                        if (feedMultLi[_i].classList.contains('active')) {
                                            multchecked.push({
                                                'id': feedMultLi[_i].dataset.code,
                                                'text': feedMultLi[_i].dataset.text,
                                                'code': feedMultLi[_i].dataset.code,
                                                'curStatus': true,
                                                'text_id': feedMultLi[_i].dataset.text_id,
                                                'active': true
                                            });
                                        }
                                    }
                                    feedData.push({
                                        question_title: multStripData[0].title,
                                        question_id: 'QUESTION_3',
                                        content_checked: {
                                            mult_checked: multchecked,
                                            another: this.player.template.feedbackMultList.querySelector('.zd_textarea').value
                                        }
                                    });
                                }
                                submitUrl = this.player.options.feedback.api || '//:' + window.location.host + '/api/feedback';
                                submitParams = {
                                    feed_content: JSON.stringify({
                                        video_url: this.player.userInfo.video_url,
                                        video_content: feedData
                                    }),
                                    teacher_id: this.player.options.feedback.teacher_id,
                                    module_type: this.player.options.feedback.module_type,
                                    batch_num: this.player.options.feedback.batch_num,
                                    feedback_sence: 'VIDEO_EVALUATE',
                                    rs_sys_ver: this.player.options.feedback.rs_sys_ver,
                                    rs_type: 'VIDEO',
                                    rs_id: this.player.options.feedback.video_id || '0',
                                    feed_type: 'JSON_REF',
                                    entity_type: 'VIDEO_EVALUATE',
                                    Token: this.player.options.feedback.token
                                };
                                if (this.player.userInfo.lmsVersion === 'vacation' || this.player.userInfo.lmsVersion === 'normalization' || this.player.userInfo.lmsVersion === 'v1' || this.player.userInfo.lmsVersion === 'v2') {
                                    submitParams.lmsVersion = this.player.userInfo.lmsVersion;
                                }
                                _context.next = 10;
                                return submitFeed(submitUrl, submitParams);
                            case 10:
                                submitInfo = _context.sent;
                                _player.hide();
                            case 12:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
                function submitFeedInfo() {
                    return _submitFeedInfo.apply(this, arguments);
                }
                return submitFeedInfo;
            }()
        },
        {
            key: 'checkSubmit',
            value: function checkSubmit() {
                var _this2 = this;
                var goal = 0;
                if (this.container.classList.contains('dplayer-feedback-wrap-mult-hide')) {
                    goal = 2;
                } else {
                    goal = 3;
                    this.submitButton.classList.add('unable');
                }
                var feedLi = document.querySelectorAll('li.dplayer-feed-content');
                var isInArray = function isInArray(item) {
                    return _this2.feed.indexOf(item) > -1;
                };
                var selectedLi = [];
                Array.prototype.slice.call(feedLi).forEach(function (item, index) {
                    if (item.classList.contains('active') && selectedLi.indexOf(item.dataset.feed) == -1) {
                        selectedLi.push(item.dataset.feed);
                    }
                });
                if (selectedLi.length == goal) {
                    this.submitButton.classList.remove('unable');
                    if (this.submitButton) {
                        this.submitButton.removeEventListener('click', this.submitButton.submit);
                    }
                    this.submitButton.submit = function () {
                        _this2.submitFeedInfo();
                    };
                    if (!this.submitButton.classList.contains('unable')) {
                        this.submitButton.addEventListener('click', this.submitButton.submit);
                    }
                } else if (selectedLi.length == 2 && goal == 3 && this.container.querySelector('.zd_textarea').value != '') {
                    this.submitButton.classList.remove('unable');
                    if (this.submitButton) {
                        this.submitButton.removeEventListener('click', this.submitButton.submit);
                    }
                    this.submitButton.submit = function () {
                        _this2.submitFeedInfo();
                    };
                    if (!this.submitButton.classList.contains('unable')) {
                        this.submitButton.addEventListener('click', this.submitButton.submit);
                    }
                }
            }
        },
        {
            key: 'initClickEvents',
            value: function initClickEvents() {
                var _this3 = this;
                this.feed = [];
                this.player.template.feedbackStripList = this.player.template.feedbackPanel.querySelector('.dplayer-feedback-strip');
                this.player.template.feedbackMultList = this.player.template.feedbackPanel.querySelector('.dplayer-feedback-mult');
                var stripEvent = function stripEvent(e) {
                    var feedLi = document.querySelectorAll('li.dplayer-feed-content');
                    Array.prototype.slice.call(feedLi).forEach(function (item, index) {
                        if (e.target.dataset.feed == item.dataset.feed) {
                            item.classList.remove('active');
                        }
                        if (_this3.feed.indexOf(item.dataset.feed) == -1) {
                            _this3.feed.push(item.dataset.feed);
                        }
                    });
                    e.target.classList.add('active');
                    if (e.target.dataset.text_id == 'NOT_LEARNED') {
                        _this3.container.classList.remove('dplayer-feedback-wrap-mult-hide');
                    } else if (e.target.dataset.text_id == 'LEARNED') {
                        _this3.container.classList.add('dplayer-feedback-wrap-mult-hide');
                    }
                    _this3.checkSubmit();
                };
                this.player.template.feedbackStripList.addEventListener('click', stripEvent);
                var multEvent = function multEvent(e) {
                    if (e.target.classList.contains('active')) {
                        e.target.classList.remove('active');
                    } else {
                        e.target.classList.add('active');
                    }
                    _this3.checkSubmit();
                };
                this.container.querySelector('.zd_textarea').addEventListener('input', function (e) {
                    console.log({ e: e });
                });
                this.player.template.feedbackMultList.addEventListener('click', multEvent);
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.feedbackPanel.classList.add('dplayer-feedback-wrap-hide');
                var feedLi = document.querySelectorAll('li.dplayer-feed-content');
                this.container.classList.add('dplayer-feedback-wrap-mult-hide');
                Array.prototype.slice.call(feedLi).forEach(function (item, index) {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    }
                });
                this.submitButton.classList.add('unable');
                if (!this.source && !this.isVideoPaused) {
                    this.player.video.play();
                }
                this.source = null;
                this.destroy();
            }
        },
        {
            key: 'show',
            value: function show(source) {
                this.player.template.feedbackPanel.classList.remove('dplayer-feedback-wrap-hide');
                this.isVideoPaused = this.player.paused;
                if (!this.isVideoPaused)
                    this.player.video.pause();
                this.source = source;
                this.init();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.container.innerHTML = '';
            }
        }
    ]);
    return Feedback;
}();
export default Feedback;